<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0">
      <div v-if="isVisible" class="fixed inset-0 z-60 flex items-center justify-center p-4">
        <!-- Backdrop -->
        <div class="absolute inset-0 bg-slate-900/60 backdrop-blur-xs" @click="dismiss" />

        <!-- Card -->
        <div class="relative z-10 w-full max-w-lg rounded-2xl bg-white p-8 shadow-2xl dark:bg-slate-800">
          <!-- Logo -->
          <div class="mb-6 flex items-center gap-3">
            <img :src="'/img/rmlogo.svg'" alt="RightMessage" class="h-8 w-auto" />
            <span class="text-lg font-bold text-slate-900 dark:text-white">RightMessage</span>
          </div>

          <!-- Content -->
          <h2 class="text-2xl font-bold text-slate-900 dark:text-white"> Welcome to the sandbox </h2>
          <p class="mt-3 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
            You're looking at a <strong>live RightMessage dashboard</strong> loaded with real-looking data. Explore how
            personalization works behind the scenes &mdash; from visitor segmentation and quiz funnels to website
            campaigns and conversion tracking.
          </p>
          <p class="mt-3 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
            Click around freely. Nothing you do here will affect a real account.
          </p>

          <!-- CTA -->
          <button
            class="mt-6 w-full rounded-lg bg-orange-500 px-5 py-3 text-sm font-semibold text-white shadow-xs transition hover:bg-orange-400 focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:outline-hidden"
            @click="dismiss">
            Let's go!
          </button>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import Button from 'primevue/button'
import { onMounted, ref } from 'vue'

const STORAGE_KEY = 'demo_welcome_dismissed'

const isVisible = ref(false)

onMounted(() => {
  if (!sessionStorage.getItem(STORAGE_KEY)) {
    isVisible.value = true
  }
})

function dismiss() {
  isVisible.value = false
  sessionStorage.setItem(STORAGE_KEY, '1')
}
</script>
